import { render, staticRenderFns } from "./error-content.vue?vue&type=template&id=98a37324"
import script from "./error-content.vue?vue&type=script&lang=js"
export * from "./error-content.vue?vue&type=script&lang=js"
import style0 from "./error.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a37324')) {
      api.createRecord('98a37324', component.options)
    } else {
      api.reload('98a37324', component.options)
    }
    module.hot.accept("./error-content.vue?vue&type=template&id=98a37324", function () {
      api.rerender('98a37324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/error-page/error-content.vue"
export default component.exports